// Shared file size limits used by upload UIs across the app.
export const ONE_MB = 1024 * 1024;
export const MAX_PHOTO_BYTES = 2 * ONE_MB;       // profile + dog photos
export const MAX_VET_FILE_BYTES = 4 * ONE_MB;    // PDFs / scans on vet records
export const MAX_COVER_BYTES = 3 * ONE_MB;       // login cover image
export const MAX_EBOOK_BYTES = 8 * ONE_MB;       // academy ebooks (PDF/EPUB)
